import React from 'react';

export default function WaveformIcon() {
  return (
    <span style={{
      display: 'inline-flex', gap: 2, alignItems: 'center', height: 14, flexShrink: 0,
    }}
    >
      <style>{'@keyframes wf{0%,100%{transform:scaleY(0.35)}50%{transform:scaleY(1)}}'}</style>
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            display: 'block',
            width: 3,
            height: '100%',
            background: 'currentColor',
            borderRadius: 2,
            animation: `wf 1.2s ${i * 0.15}s ease-in-out infinite`,
          }}
        />
      ))}
    </span>
  );
}
